export const tabs:string[] = ['Tout', 'UI Design', 'web', 'Mobile','desktop'];